import { render } from "./ContactsRoute.vue?vue&type=template&id=32ba7faa"
import script from "./ContactsRoute.vue?vue&type=script&lang=js"
export * from "./ContactsRoute.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/nahodka.xpage.dev/htdocs/public/local/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__